/* global AZURE_URI, LOCALE */

import { Price } from '../classes/Price'

const priceEl = document.querySelector('.units-about__price')
const occupancyEl = document.querySelector('.units-about__occupancy')

async function getUnit () {
  const { propertyId, unitId } = document.querySelector('main').dataset
  if (propertyId) {
    const url = `${AZURE_URI}GetProperty?id=${propertyId}&locale=${LOCALE}`
    try {
      const response = await fetch(url)
      const { units } = await response.json()
      const unit = units.find(u => u.unitId === unitId)
      return unit ? { ...unit, price: unit.rateFrom ? new Price(unit.rateFrom, unit.currency) : null } : null
    } catch (err) {
      console.error('getUnit', err)
    }
  }
}

async function writeData () {
  const unit = await getUnit()
  if (unit) {
    if (unit.price) {
      priceEl.append(unit.price.display)
    } else {
      priceEl.textContent = ''
    }

    const occupancyAdult = unit['@OccupancyMaxAdult'] ?? unit['@OccupancyMax']
    const occupancyChildren = unit['@OccupancyMax'] - occupancyAdult

    const adultIcon = '<i class="icon-adult"></i>'
    const childIcon = '<i class="icon-child"></i>'
    occupancyEl.innerHTML = adultIcon.repeat(occupancyAdult) + childIcon.repeat(occupancyChildren)
  }
}

writeData()
